<template>
  <main class="policy-page">
    <h1>広告について</h1>

    <p>
      当サイトは、運営費用の一部をまかなうため、広告およびアフィリエイトリンクを掲載する場合があります。
    </p>

    <section>
      <h2>広告配信について</h2>
      <p>
        当サイトでは、第三者配信の広告サービスを利用する場合があります。広告配信事業者は、利用者の興味に応じた広告を表示するため、Cookie などを使用することがあります。
      </p>
    </section>

    <section>
      <h2>アフィリエイトリンクについて</h2>
      <p>
        当サイトに掲載されるリンクの一部には、アフィリエイトリンクが含まれる場合があります。リンク先で商品やサービスを購入・申込された場合、当サイトが紹介料を受け取ることがあります。
      </p>
    </section>

    <section>
      <h2>掲載方針</h2>
      <p>
        公演情報、公式ブログ、公式チケットサイトへの案内は、広告・アフィリエイト目的のリンクとは区別して掲載します。最新かつ正確な情報は、必ず公式サイトをご確認ください。
      </p>
    </section>
  </main>
</template>

<script>
export default {
  name: "AdvertisingPolicy",
};
</script>

<style scoped>
.policy-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 16px;
  color: #444;
  text-align: left;
}

.policy-page h1 {
  margin-bottom: 20px;
  color: #4a4a4a;
  font-size: 24px;
  text-align: center;
}

.policy-page h2 {
  margin: 24px 0 8px;
  color: #4a4a4a;
  font-size: 18px;
}

.policy-page p {
  line-height: 1.7;
}
</style>
